import React, { FC } from 'react';
import styled from 'styled-components';

import { LoaderIcon } from '~/atomic/atom/icon/LoaderIcon';
import { AuthorLink, BookLink } from '~/atomic/atom/links/dynamicLinks';
import { useGetWinnerContestBook } from '~/atomic/page/contest/ContestResult/contestResult.data';
import { ContestWinnerBook } from '~/atomic/page/contest/ContestResult/ContestWinnerBook';
import {
  PageTitleStyle, TextBoldStyle, TextRegStyle,
} from '~/atomic/Typography';

export interface ContestResultProps {
  // eslint-disable-next-line react/no-unused-prop-types
  winnerBookSlugs: Array<string>;
  // eslint-disable-next-line react/no-unused-prop-types
  secondPlace: Array<string>;
  // eslint-disable-next-line react/no-unused-prop-types
  thirdPlace: Array<string>;
  // eslint-disable-next-line react/no-unused-prop-types
  shortList: Array<string>;
}

export const ContestResult: FC<ContestResultProps> = (props) => {
  const { data: results, isLoading } = useGetWinnerContestBook(props);

  return (
    <SCContestResult>
      <SCTitle>
        Пришло время подвести результаты конкурса!
      </SCTitle>
      {isLoading ? (
        <SCLoaderWrapper>
          <SCLoaderIcon />
        </SCLoaderWrapper>
      ) : null}
      {!isLoading
        ? (
          <>
            {results?.winners.length === 1 && results?.secondPlace.length === 0
              ? (
                <>
                  <SCWinnerTitle>
                    Победитель
                  </SCWinnerTitle>
                  {results?.winners?.map((winnerBook) => (
                    <ContestWinnerBook winnerBook={winnerBook} />
                  ))}
                </>
              )
              : (
                <>
                  <SCWinnerTitle>
                    Первое место
                  </SCWinnerTitle>
                  {results?.winners?.map((winnerBook) => (
                    <ContestWinnerBook winnerBook={winnerBook} />
                  ))}
                  <SCWinnerTitle>
                    Второе место
                  </SCWinnerTitle>
                  {results?.secondPlace?.map((winnerBook) => (
                    <ContestWinnerBook winnerBook={winnerBook} />
                  ))}
                  <SCWinnerTitle>
                    Третье место
                  </SCWinnerTitle>
                  {results?.thirdPlace?.map((winnerBook) => (
                    <ContestWinnerBook winnerBook={winnerBook} />
                  ))}
                  <SCWinnerTitle>
                    Дополнительно прошедшие в шорт-лист
                  </SCWinnerTitle>
                  <SCShortListWrapper>
                    {results?.shortList?.map((book) => (
                      <SCShortListItem>
                        <AuthorLink username={book.author.username}>
                          <SCShortListAuthor>
                            {book.author.name}
                          </SCShortListAuthor>
                        </AuthorLink>
                        -
                        <BookLink slug={book.slug}>
                          <SCShortListBookName>
                            {book.name}
                          </SCShortListBookName>
                        </BookLink>
                      </SCShortListItem>
                    ))}
                  </SCShortListWrapper>
                  <SCTitle>
                    Со всеми финалистами
                    (и занявшими призовые места и теми, кто остался в шорт-листе)
                    свяжутся в ближайшее время через почтовый адрес,
                    который вы указывали при регистрации на нашем портале.
                    {' '}
                    <br />
                    Администрация портала поздравляет победителей и благодарит всех за участие в конкурсе!
                  </SCTitle>
                </>
              )}
          </>
        )
        : null}
    </SCContestResult>
  );
};

const SCContestResult = styled.div`
  > *:not(:last-child) {
    margin-bottom: 30px;
  }
`;

const SCTitle = styled.h3`
  ${TextBoldStyle};
  text-align: center;
  margin-bottom: 20px;
`;

const SCWinnerTitle = styled.h2`
  ${PageTitleStyle};
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
`;

const SCShortListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px
`;

const SCShortListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px
`;

const SCShortListAuthor = styled.a`
  ${TextRegStyle};
  color: var(--gray-color);
`;

const SCShortListBookName = styled.a`
  ${TextRegStyle};
  color: var(--black-color);
`;

const SCLoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
`;

const SCLoaderIcon = styled(LoaderIcon)`
  width: 120px;
  height: 120px;
`;
